/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSupervisorDto } from './GetSupervisorDto';
import {
    GetSupervisorDtoFromJSON,
    GetSupervisorDtoFromJSONTyped,
    GetSupervisorDtoToJSON,
} from './GetSupervisorDto';

/**
 * 
 * @export
 * @interface GetSupervisorsDto
 */
export interface GetSupervisorsDto {
    /**
     * 
     * @type {Array<GetSupervisorDto>}
     * @memberof GetSupervisorsDto
     */
    supervisors: Array<GetSupervisorDto>;
}

/**
 * Check if a given object implements the GetSupervisorsDto interface.
 */
export function instanceOfGetSupervisorsDto(value: object): value is GetSupervisorsDto {
    if (!('supervisors' in value) || value['supervisors'] === undefined) return false;
    return true;
}

export function GetSupervisorsDtoFromJSON(json: any): GetSupervisorsDto {
    return GetSupervisorsDtoFromJSONTyped(json, false);
}

export function GetSupervisorsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupervisorsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'supervisors': ((json['supervisors'] as Array<any>).map(GetSupervisorDtoFromJSON)),
    };
}

export function GetSupervisorsDtoToJSON(value?: GetSupervisorsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'supervisors': ((value['supervisors'] as Array<any>).map(GetSupervisorDtoToJSON)),
    };
}

